<style scoped lang="less">
.choiostitle {
	display: flex;
	padding: 0.8rem 0.4rem;
	align-items: center;
	justify-content: space-between;
	background-color: #fff;
	margin-bottom: 1rem;
	border-left: 4px solid #ab26aa;

	.choiostitleleft {
		padding: 0.5rem;
		font-size: 0.8rem;
		border-radius: 50%;
		color: #fff;
		background-color: #ab26aa;
		border: 1px solid;
		text-align: left;
		margin-left: 0.6rem;
		box-sizing: border-box;

		span {
			font-weight: 900;
			font-size: 1.2rem;
		}
	}

	.choiostitleright {
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}
}
</style>
<template>
	<div>
		<titles titlename="我的考试" titlecontent="这里可以看到我的考试一些信息" :mbx="paths"></titles>
		<div class="choiostitle">
			<button class="choiostitleleft "><span class="el-icon-wallet"></span></button>
			<div class="choiostitleright col-xs-8 col-sm-8 col-md-8 col-lg-8"></div>
		</div>
		<div style="background-color: #fff;margin-top: 30px;">
			<el-tabs type="border-card" @tab-click="changeeaxmins">
			  <el-tab-pane label="我的考试">
				  <el-table :data="tableData1" center header-row-class-name="tablestitle" border style="width: 100%">
				  	<el-table-column fixed align="center" prop="SPA_PaperTitle" label="试卷名称" width="200"></el-table-column>
				  	<el-table-column  label="创建试卷时间" align="center">
				  		<template slot-scope="scope">
				  			{{scope.row.SPA_CreatetTime.indexOf("T")>0?scope.row.SPA_CreatetTime.replace("T"," "):scope.row.SPA_CreatetTime}}
				  		</template>
				  	</el-table-column>
				  	
				  	<el-table-column prop="SPA_Duration" align="center" label="考试时间(分钟)"></el-table-column>
				  	<el-table-column prop="SPA_Scores" align="center" label="总分"></el-table-column>
				  	<el-table-column prop="SSP_Scores" align="center" label="得分"></el-table-column>
					<el-table-column label="操作" align="center">
						<template slot-scope="scope">
							<p @click="goexmins(id)" style="color: #fff;background-color: red;width: 100px;border-radius: 10px;margin: auto;cursor: pointer;">开始考试</p>
						</template>
					</el-table-column>
				  </el-table>
			  </el-tab-pane>
			  <el-tab-pane label="考试详情">
				  <el-table :data="tableData" center header-row-class-name="tablestitle" border style="width: 100%">
				  	<el-table-column fixed align="center" prop="SPA_PaperTitle" label="试卷名称" width="200"></el-table-column>
				  	<el-table-column  label="考试开始时间" align="center">
				  		<template slot-scope="scope">
				  			{{scope.row.SSP_StartTime.indexOf("T")>0?scope.row.SSP_StartTime.replace("T"," "):scope.row.SSP_StartTime}}
				  		</template>
				  	</el-table-column>
				  	<el-table-column label="考试结束时间" align="center">
				  		<template slot-scope="scope">
				  			{{scope.row.SSP_EndTime.indexOf("T")>0?scope.row.SSP_EndTime.replace("T"," "):scope.row.SSP_EndTime}}
				  		</template>
				  	</el-table-column>
				  	<el-table-column prop="SPA_Duration" align="center" label="考试时间(分钟)"></el-table-column>
				  	<el-table-column prop="SPA_Scores" align="center" label="总分"></el-table-column>
				  	<el-table-column prop="SSP_Scores" align="center" label="得分"></el-table-column>
				  </el-table>
			  </el-tab-pane>
			  
			</el-tabs>
			
			
		</div>
	</div>
</template>

<script>
import titles from '@/components/title/title.vue';

import { getGetusersentpaper,getGetusersentpapers } from '@/request/api/pingtai/terrace.js';


export default {
	data() {
		return {
			// 标题
			paths: [
				{
					path: '/usercenter/homesview/testists/Myexamind',
					name: '我的考试'
				}
			],
			tableData: [],
			tableData1:[],
			iseaminxs:0
		};
	},
	mounted() {
		if(this.iseaminxs == 0){
			this.changeeaxmin()
		}else{
			this.getQuestionBank()
		}
	},
	methods:{
		getQuestionBank(){
			let uiguids = localStorage.getItem("uiguid")
			getGetusersentpaper(uiguids).then(res=>{
				if(res.data.code>=0){
					this.tableData = res.data.data
				}
			})
		},
		changeeaxmin(){
			let uiguids = localStorage.getItem("uiguid")
			getGetusersentpapers(uiguids).then(res=>{
				if(res.data.code>=0){
					this.tableData1 = res.data.data
				}
			})
			
		},
		changeeaxmins(e){
			// console.log(e)
			this.iseaminxs =e.paneName
			if(e.paneName=="1"){
				this.getQuestionBank()
			}else{
				this.changeeaxmin()
			}
		},
		goexmins(){
			this.$router.push("/pageme/examine")
		},
		
		
	},
	components: {
		titles
	}
};
</script>
